export * from './__generated__/update-widget-setting-mutation.generated';
